export default "__VITE_ASSET__CGaw_ML9__"